import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import './styles/subjectPage.scss'
import Lesson from '../../components/Lesson';
import ProgressCircle from '../../components/ProgressCircle';
import PageHeader from '../../components/PageHeader';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import { readJson } from '../../apiHelper/readJson';

export default function SubjectPage({ subject }: any) {
    const [lessons, setLessons] = useState([]);
    const [progress, setProgress] = useState(0);
    const [fetched, setFetched] = useState(false);

    const headers: { [key: string]: string } = { "physics": "Fyzika", "chemistry": "Chemie", "biology": "Biologie" };
    const images: { [key: string]: string } = { "physics": "atom", "chemistry": "isopropanol", "biology": "cell" };

    const api = new ApiHelper();

    async function fetch() {
        try {
            const res = await api.lessonsApi.getLessonsDetail(subject);
            const proc = await readJson(res);
            setLessons(proc.lessons);

            const resProg = await api.lessonsApi.getProgressList();
            const procProg = await readJson(resProg);

            switch (subject) {
                case "physics": setProgress(procProg.physicsProgress); break;
                case "chemistry": setProgress(procProg.chemistryProgress); break;
                case "biology": setProgress(procProg.biologyProgress); break;
                default: break;
            }
        } catch (x: any) {
            api.processErrors(x);
        }
    }

    useEffect(() => {
        if (!fetched) {
            fetch();
            setFetched(true);
        }
    }, []);

    return (
        <div className="subjectPage">
            <Link to=".." className="backLink">← Zpět na materiály</Link>
            <PageHeader
                title={headers[subject]}
                subtitle={lessons.length + " lekcí"}
                right={<ProgressCircle value={progress} img={"/images/components/" + images[subject] + ".png"} />}
            />

            <div className="lessonPath">
                {lessons.length > 0 &&
                    <div className="pathStop start" title="Začátek">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M6 4v16" />
                            <path d="M6 5h11l-2.5 3.5L17 12H6" />
                        </svg>
                    </div>
                }

                {(lessons.length > 0) && lessons.map((l: any) => (
                    <Lesson key={l.number} number={l.number.toString()} title={l.title} motto={l.caption} completed={l.isCompleted} />
                ))}

                {lessons.length > 0 &&
                    <div className="pathStop end" title="Cíl">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12.5l4.5 4.5L19 7.5" />
                        </svg>
                    </div>
                }
            </div>
        </div>
    );
}
